import React from 'react'
import { ConfigProvider } from 'antd'
import Routes from './routes'
import 'bootstrap/dist/css/bootstrap.min.css'

const App = () => (<ConfigProvider theme={{
  token: {
    colorPrimary: '#490c4e'
  }
}}
                   > <Routes /> </ConfigProvider>)

export default App
